<p>
  The print version of the Development Stage Matrix has been opened for you in a new browser tab and the
  Print Window automatically opened.
  <b>
    NOTE: In order to return Chrome to an active state this Print Window will need to be closed before DigiRES
    can be used again.
  </b>
</p>
<p>
  For best results you should use the following settings in the Print Window:
</p>
<ul>
  <li>
    For the Destination you can select to 'print' to:
    <ul>
      <li>
        a PDF (The “Save as PDF…” option will save the Development Stage Matrix as a PDF file on your Computer)
      </li>
      <li>
        the printer of your choice to print the Development Stage Matrix directly to paper.
      </li>
    </ul>
  </li>
  <li>
    Set the Layout to Landscape
  </li>
  <li>
    Under the ‘More Settings’ options (you may need to expand this to see these options) make sure that:
    <ul>
      <li>
        the paper size is selected (e.g. A4)
      </li>
      <li>
        Scale: Select “Customised” and set the scale factor depending on the paper size.
      </li>
      <li>
        the 'Background graphics' checkbox is selected
      </li>
      <li>
        If you tick 'Headers and Footers' this will include the date in the Header and the DigiRES URL in the footer
      </li>
    </ul>
  </li>
  <li>
    When the settings have been applied click the ‘Print’ button
  </li>
</ul>
<p>
  In order to return Chrome to an active state the Print Window will need to be closed before DigiRES can be used again.
</p>
<mat-dialog-actions>
  <button mat-button class="save" [mat-dialog-close]="false">Close</button>
</mat-dialog-actions>
